import { makeStyles } from 'tss-react/mui';

const name = 'ChainSelectors';

export const useChainSelectorsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
  },
  tabsWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  tabsInner: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  tab: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
    },
  },
}));
